import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { ModalService } from '../../../services/modal.service';
import { IMessengerConnector, Message, SendMessage } from '../../../types/all.type';
import { AppService } from '../../../services/app.service';
import { InterfaceService } from "../../../services/interface.service";


@Component({
  selector: 'app-message-service',
  templateUrl: './message-service.component.html',
  styleUrls: ['./message-service.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageServiceComponent implements OnInit {
  @Input() message: Message;
  @Input() index: number;
  @Input() Service: IMessengerConnector;

  constructor(
    public interfaceService: InterfaceService,
    public appService: AppService,
    public modalService: ModalService,
    private cd: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this.cd.detach();
    this.cd.detectChanges();
  }

  openDetailInfo(id) {
    this.modalService.openModal('ModalChatDetailComponent', {
      Service: this.Service,
      id: id,
      type: 'user'
    });
  }

  openMessages(messages: Message[]): void {
    this.modalService.openModal('ModalMessagePinnedComponent', {
      messages: messages,
      Service: this.Service
    });
  }

  sendMessage(): void {
    const arMessage: SendMessage = {
      chat_id: this.Service.openChatId,
      chat_type: this.Service.openChat.type,
      text: 'Hi',
      attachments: []
    };
    this.Service.sendMessage(arMessage).subscribe((res) => {

      },
      error => {
        this.interfaceService.errorHandling(error);
      });
  }
}
